import { BadgeColor, BadgeType, DeliveryItem, FeaturedCard, Relationship } from './types';

export const PLACEHOLDER_ITEM_PREFIX = 'pop-item-';

export const CUSTOM_ITEM_THUMBNAIL_IMAGE = 'https://postdates.s3-us-west-1.amazonaws.com/items/custom+item.png';
export const CUSTOM_ITEM_DETAIL_IMAGE =
  'https://postdates.s3.us-west-1.amazonaws.com/items-full/add-custom-item-page.jpg';

export const getFeaturedCards = (): FeaturedCard[] => {
  return [
    {
      id: 'how',
      name: 'How to Postdate',
      details: 'Learn More',
      lightText: true,
      url: '/how-to',
      external: false,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/featured/about.jpg',
    },
    {
      id: 'faq',
      name: 'FAQ',
      lightText: true,
      details: 'Your Questions, Answered',
      url: '/faq',
      external: false,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/featured/FAQ.jpg',
    },
    {
      id: 'refer',
      name: 'Refer a Friend',
      details: 'Make their breakup a little less painful',
      lightText: false,
      url: 'https://postdates.co',
      external: true,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/featured/refer+a+friend.jpg',
    },
    {
      id: 'testimonials',
      name: 'Testimonials',
      details: 'What People Are Saying',
      lightText: false,
      url: 'https://twitter.com/search?q=postdates&src=typed_query',
      external: true,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/featured/testimonials.jpg',
    },
  ];
};

export const getRelationships = (): Relationship[] => {
  return [
    {
      id: 'casual',
      name: 'Casually Dated',
      description: 'Even the sun sets in paradise.',
      shortDescription: 'On to the next.',
      longDescription: 'Even the sun sets in paradise.',
      timing: '3-6 months',
      imageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationships-full/dating-casually-6-27.jpg',
      coverImageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationship-detail/dating-casually-cover.jpg',
      popular: true,
      badgeColor: BadgeColor.purple,
      badgeType: BadgeType.popular,
      rIdx: 0,
      sIdx: 6,
    },
    {
      id: 'lived-together',
      name: 'Lived Together',
      description: 'Books? Sure. Peloton? No.',
      shortDescription: 'Books? Sure. Peloton? No.',
      longDescription: 'Books? Sure. Peloton? No.',
      timing: '2-9 years',
      imageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationships-full/living-together-6-27.jpg',
      coverImageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationship-detail/living-together-cover.jpg',
      popular: true,
      badgeColor: BadgeColor.pink,
      badgeType: BadgeType.new,
      rIdx: 1,
      sIdx: 5,
    },
    {
      id: 'one-night-stand',
      name: 'One Night Stand',
      description: 'Care to explain? Us neither.',
      shortDescription: 'Care to explain? Us neither.',
      longDescription: 'Care to explain? Us neither.',
      timing: '1 night',
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/relationships/one-night-stand.jpg',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/relationships-full/one+night+stand.jpg',
      popular: true,
      badgeColor: BadgeColor.purple,
      badgeType: BadgeType.popular,
      rIdx: 2,
      sIdx: 0,
    },
    {
      id: 'hookup',
      name: 'Hooked Up',
      description: 'No strings attached.',
      shortDescription: 'No strings attached.',
      longDescription: 'No strings attached.',
      timing: '1-30 days',
      imageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationships-full/casual-hook-up-6-27.jpg',
      coverImageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationship-detail/casual-hook-up-cover.jpg',
      popular: false,
      badgeColor: BadgeColor.red,
      badgeType: BadgeType.top,
      rIdx: 3,
      sIdx: 2,
    },
    {
      id: 'serious',
      name: 'Seriously Dated',
      description: 'And then there was one.',
      shortDescription: 'And then there was one.',
      longDescription: 'And then there was one.',
      timing: '1-2 years',
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/relationships/dating-seriously.jpg',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/relationships-full/dating+seriously.jpg',
      popular: false,
      badgeColor: BadgeColor.purple,
      badgeType: BadgeType.popular,
      rIdx: 4,
      sIdx: 4,
    },
    {
      id: 'slept-ex',
      name: 'Went Back To Your Ex',
      description: 'You went back again (and again)...',
      shortDescription: 'Again (and again)...',
      longDescription: 'You went back again (and again)...',
      timing: 'Indefinite',
      imageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationships-full/ex-6-27.jpg',
      coverImageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationship-detail/ex-cover.jpg',
      popular: true,
      badgeColor: BadgeColor.pink,
      badgeType: BadgeType.only,
      rIdx: 5,
      sIdx: 3,
    },
    {
      id: 'friendzone',
      name: 'Friendzoned',
      description: 'It happens to the best of us.',
      shortDescription: 'It happens.',
      longDescription: 'It happens to the best of us.',
      timing: 'N/A',
      imageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationships-full/friendzone-6-27.jpg',
      coverImageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationship-detail/friendzone-cover.jpg',
      popular: true,
      badgeColor: BadgeColor.purple,
      badgeType: BadgeType.popular,
      rIdx: 6,
      sIdx: 7,
    },
    {
      id: 'divorce',
      name: 'Divorced',
      description: 'Oof. That sucks.',
      shortDescription: 'Oof. That sucks.',
      longDescription: 'Oof. That sucks.',
      timing: '10+ years',
      imageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationships-full/married-6-27.jpg',
      coverImageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/relationship-detail/married-cover.jpg',
      popular: false,
      badgeColor: BadgeColor.red,
      badgeType: BadgeType.deal,
      rIdx: 7,
      sIdx: 1,
    },
    {
      id: 'other',
      name: 'Other',
      description: `For any other non-romantic situation.`,
      shortDescription: 'Non-romantic situations.',
      longDescription: `Friend? Ex-Roommate? Old boss? We're here for whatever awkward situation you find yourself in.`,
      timing: 'Anything',
      imageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/app/custom-bag.jpg',
      coverImageUrl: 'https://postdates.s3.us-west-1.amazonaws.com/app/custom-bag.jpg',
      popular: false,
      badgeColor: BadgeColor.pink,
      badgeType: BadgeType.new,
      rIdx: 8,
      sIdx: 8,
    },
  ];
};

/**
 * Gets popular items for each relationship. Not strongly typed.
 */
export const getPopularItems = (relationshipId: string): DeliveryItem[] => {
  switch (relationshipId) {
    case 'divorce':
      return getDivorceItems();
    case 'lived-together':
      return getLivedTogetherItems();
    case 'serious':
      return getSeriousItems();
    case 'casual':
      return getCasualItems();
    case 'slept-ex':
      return getExedItems();
    case 'hookup':
      return getHookupItems();
    case 'one-night-stand':
      return getOneNightStandItems();
    case 'friendzone':
      return getFriendzoneItems();
    case 'other':
    default:
      return [];
  }
};

const getFriendzoneItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}friendzone-1`,
      name: 'Basketball',
      description: `Shooting hoops probably wasn’t the best way to get them to fall in love with you.... unless you're Larry Bird? But we don't think you are. Colors vary.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/basketball.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/baskteball.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}friendzone-2`,
      name: 'Event Tickets',
      description: `Either upcoming or in the past, these items probably weren't cheap. Commonly holds specific memories or dates.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/halloween-+ticket.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/halloween+horror+nights+ticket.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}friendzone-3`,
      name: 'Kneepads',
      description: `Did you take them roller skating? Why did you bring these over?`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/kneepads.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/knee+pads.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}friendzone-4`,
      name: 'Muffin Pan',
      description: `Usually found in a 12 count (4x3) metal tin, this item is quick to enter "we're just friends" relationship territory. Don't let that happen. Get it back now, with Postdates.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/muffin-pan.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/muffin+pan.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}friendzone-5`,
      name: 'Twister',
      description: `We know you hoped for a romcom experience, but this form of entertainment often results in the opposite. Headaches, fights, and/or missing pieces are common side effects. Game over or not, draw the line somewhere and get it out of there.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/twister.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/twister.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

const getOneNightStandItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}one-night-stand-1`,
      name: '3M Mask',
      description: `Since March 2020, masks are highly sought after. Used as the main source of protection from the coronavirus (in addition to hand washing), this item is medical grade and can be reused if uncontaminated.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/3m+mask.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/3M+mask.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}one-night-stand-2`,
      name: 'Earrings',
      description: `These accessories are an upgrade to any look, though they are easy to misplace or lose. Made for pierced ears. Commonly left on the nightstand.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/EARRINGS.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/earrings.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}one-night-stand-3`,
      name: 'Purse',
      description: `From classic to couture, this item holds entire lives, stories, and secrets. As a famous poet once quoted: Gucci, Gucci, Louis, Louis, Fendi, Fendi, Prada.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/purse.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/purse.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}one-night-stand-5`,
      name: 'Undies',
      description: `We kindly ask that this item has been thoroughly cleaned before returning. Often comes in a variety of shapes and sizes, ranging from thongs to boxers to long johns.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/undies.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/undies.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}one-night-stand-6`,
      name: 'Wallet',
      description: `The essentials. Like, the serious essentials. This item often includes credit cards, debit cards, cash, and your state's legal identification card. One night stand responsibly.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/wallet.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/wallet.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

const getHookupItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}hookup-1`,
      name: 'Hoodie',
      description: `The most commonly requested item on Postdates. Featured in a variety of colors, this item is often lent out due to cold weather and never returned willingly or in a timely fashion. Everyone has one somewhere out the in the world. Get it back now.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/hoodie.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/hoodie.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}hookup-2`,
      name: 'iPhone Charger',
      description: `Featuring an ultracompact design, this power adapter and charging cable offers fast, efficient charging at home, in the office, or on the go. It works with any Apple Watch, iPhone, or AirPods. This item is a must-have.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/iphone+charger.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/phone-charger.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}hookup-3`,
      name: 'Smoking Paraphanalia',
      description: `Lighters, bongs, pipes — we've seen it all. These instruments are used for the recreational (or in some cases medicinal) use of marijuana and/or tobacco. Absolutely NO crack pipes allowed. Comes in various shapes and sizes.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/smoking+paraphanalia.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/smoking-paraphanelia.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}hookup-4`,
      name: 'Watch',
      description: `This item is a portable timepiece intended to be carried or worn by a person, usually on the wrist. And now it looks like it's time to move on. Common brands: Rolex, Casio.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/watch.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/watch.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

const getExedItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}exed-1`,
      name: 'iPhone',
      description: `Some argue that this item is the world's most advanced mobile device. Others would say they prefer Android (though they are wrong). From the edge-to-edge liquid retina display, this item is not only gorgeous and immersive, but also incredibly handy. And more responsive than your ex.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/iphone.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/iphone.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}exed-2`,
      name: 'Love Letter',
      description: `There's something about a good, old-fashioned love letter—especially a handwritten one—that makes it a rare and special treat. They are keepsakes that can be held, reread, cherished, and burned to ashes after a drop of virgin blood is placed on the paper in preparation for the love spell you recite to get them back for the 80th time.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/love-letter.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/love-letter.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}exed-3`,
      name: 'Toys',
      description: `This item is considered a toy for adults, often explicitly phallic in appearance, intended for either solitary activity or an event with partners. It can be made from a number of materials including silicone, metal, and rubber. Typically 4–6" in length, but may be longer depending on preference.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/toys.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/sex+toys.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

const getCasualItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}casual-1`,
      name: 'Camera',
      description: `Honestly the most prized possession in one way or another. This item holds the past, the present, and the future. Ranging in pricing and color — this item is a must have when it comes to getting it back.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/film-camera.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/film+camera.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}casual-2`,
      name: 'Lip Gloss',
      description: `Available in a variety of shades and sizes, this items helps to make your lips the softest and shiniest things to ever touch someone else's face. The person whose place you left this at is undeserving.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/glossier.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/glossier.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}casual-3`,
      name: 'Laptop Charger',
      description: `A power supply for electronic devices. Also called an "AC adapter" or "charger," this item plugs into a wall outlet to give life to your computer. Common brands: Dell, Apple.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/laptop-charger.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/laptop+charger.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}casual-4`,
      name: 'Mixtape',
      description: `An ode to the 80's. This item is a compilation of songs, usually recorded from another source and most likely made out of love and admiration. This item holds sentimental value.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/mixtape.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/mixtape.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}casual-5`,
      name: 'Sunglasses',
      description: `Prescription or not, this item protects your eyes from harsh UV rays. The cost varies drastically and these are commonly lost or misplaced. Stay cool, Ponyboy.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/sunglasses2.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/sunglasses.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}casual-6`,
      name: 'Toothbrush',
      description: `This is an oral hygiene instrument used to clean the teeth, gums, and tongue. Asking for the non-electric version of this item back can be considered petty, though sentimental.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/toothbrush.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/toothbrush.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}casual-7`,
      name: "We're Not Really Strangers",
      description: `You might have played this when you first met — or with the hope of rekindling an old flame. You probably learned more about yourself and your partner, who you ultimately chose to leave in the past.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/WNRS.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/WNRS.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

const getSeriousItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}serious-1`,
      name: 'Bath Products',
      description: `Face wash, lotion, serums, lip treatments, face masks, and more. These items can be considered essential to the requester. Can also be associated with a small travel bag/dopp kit used for short, but frequent overnight visits.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/aesop.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/Aesop.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}serious-2`,
      name: 'Chessboard',
      description: `Listen, we all thought we were chess masters after watching The Queen's Gambit. It was probably also romantic at the time. It is commonly featured in several sizes and colors.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/chessboard.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/chess+board.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}serious-3`,
      name: 'House Key',
      description: `Can be a singular key or a set of keys associated with the location. Common colors are gold & silver. Please do not expect the key ring to return. This item usually belongs to the initiator of the request.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/key.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/key.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

const getLivedTogetherItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}living-together-1`,
      name: 'Cast Iron Skillet',
      description: `Usually weighing between 4-12 lbs, these are primarily used for the gourmet cooking of eggs, meat, fish, dutch babies, and even vegetables.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/skillet.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/cast+iron+skillet.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}living-together-2`,
      name: 'Dog Bowls',
      description: `Your dog was in this relationship, too. And they also need to move on. Common materials: ceramic, steel.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/dog-bowls.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/dog+bowls.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}living-together-3`,
      name: 'Drill',
      description: `Usually compact and lightweight, this item is made for home renovation. We're guessing that since you recently moved, it'd be nice to have it back. Don't forget the bits!`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/drill.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/drill.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}living-together-4`,
      name: 'Weights',
      description: `Move over, Jane Fonda! These items are made for getting — or staying — on your journey towards feeling and being your best self, which will be a lot easier now that your ex is gone. NOTE: Postdates orders must be under 25 lbs total.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/weights.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/weights.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}living-together-5`,
      name: 'Xbox (Game Console)',
      description: `The most coveted video game console on the market is the PS5 (next to the Nintendo Switch). Next is the Xbox 360 (pictured). For serious gamers only.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/xbox.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/xbox.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

const getDivorceItems = (): DeliveryItem[] => {
  return [
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}divorce-1`,
      name: 'Bills',
      description: `Paper documents not commonly found online. This may include 1099's, mortgage papers, tax documents, living will & testament, parking permits, etc.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/bills.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/bills.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}divorce-2`,
      name: 'Family Heirloom',
      description: `This item is memorable, generational, and often priceless in what it holds. Notable items include framed photographs, pocket watches, jewelry, and handwritten letters.`,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/family+heirloom.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/family+heirloom.jpg',
      quantity: 1,
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}divorce-3`,
      name: 'ID Card',
      description: `A government (or other official) form of picture and/or visual identification. Essential item.`,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/insurance+card.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/health+insurance+card.jpg',
      quantity: 1,
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}divorce-4`,
      name: 'VHS',
      description: `Home videos, sex tapes, or maybe just a Hollywood classic such as "Lassie" or "The Wizard of Oz." This item usually comes with sentimental recorded content not available elsewhere.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/VHS.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/VHS.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    {
      id: `${PLACEHOLDER_ITEM_PREFIX}divorce-5`,
      name: 'Wedding Ring',
      description: `Commonly found in gold and/or silver bands. Usually features a diamond or other kind of gemstone. This item symbolizes too much for a text description.`,
      quantity: 1,
      imageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items/wedding+ring.png',
      coverImageUrl: 'https://postdates.s3-us-west-1.amazonaws.com/items-full/wedding+ring.jpg',
      available: false,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
  ];
};

export const getRelationship = (relationshipId?: string): Relationship | undefined => {
  if (!relationshipId) {
    return undefined;
  }

  return getRelationships().find((r) => r.id === relationshipId);
};

export const getAllItems = (): { [itemId: string]: DeliveryItem } => {
  const items: { [itemId: string]: DeliveryItem } = {};

  getRelationships().forEach((relationship) => {
    getPopularItems(relationship.id).forEach((item) => {
      items[item.id] = item;
    });
  });

  return items;
};
